import Modal from '../components/Modal/Modal'
import Header from '../components/Header/Header'
import { Link, useSearchParams, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { fetchAPI } from '../helpers/api'
import { useContext } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import Status from '../enums/Status'

const PaymentSuccess = () => {
    const { token } = useContext(AuthContext)
    const navigate = useNavigate()
    const [queryParams] = useSearchParams()
    const paymentId = queryParams.get('paymentId')

    useEffect(() => {
        const updatePayment = async () => {
            const res = await fetchAPI(
                `${process.env.REACT_APP_API_URL}/payments/${paymentId}`,
                {
                    method: 'PATCH',
                    headers: {
                        Authorization: `Bearer ${token.access_token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        status: Status.inReview,
                    }),
                }
            )

            return res
        }

        if (!paymentId) {
            return
        }

        updatePayment()
        navigate('/payment/success', { replace: true })
    }, [paymentId])

    const link = (
        <Link to="/payments" className=" text-sky-700">
            “Ιστορικό Πληρωμών”
        </Link>
    )

    return (
        <>
            <Modal classes="w-full max-w-7xl flex flex-col">
                <Header
                    includeLogo={true}
                    withBorder={true}
                    includeButtons={true}
                />
                <div className="w-full flex items-center flex-col py-20">
                    <div className="max-w-2xl py-10">
                        <h1 className="mb-8 text-xl text-center font-bold">
                            Η πληρωμή σας πραγματοποιήθηκε!
                        </h1>

                        <p className="text-center text-secondary text-md">
                            Μπορείτε να δείτε τις πληρωμές σας στο
                            {link}
                        </p>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default PaymentSuccess
